export class EquipamentoSiloModel {
    public id!: number;
    public coletorEquipamentoReferencia?: number;
    public tipo?: string;
    public categoria?: string;
    public nome: string;
    public intervaloHistorico?: number;
}
